import { Link } from '@remix-run/react';
import { Badge } from 'react-bootstrap';

import { HighlightedTaxon } from '~/types/Taxon';

// Rendered width of `.homepage__taxon_card` (homepage.scss): 80% below the `sm` breakpoint
// (576px), 40% between `sm` and `lg` (992px), a plain 25vw column (`Col xs={3}`) from `lg` up.
const TAXON_CARD_SIZES = '(max-width: 575px) 80vw, (max-width: 991px) 40vw, 25vw';

const TaxonCard = ({ taxon }: { taxon: HighlightedTaxon }) => {
  return (
    <Link className="taxon-card" to={taxon.link} aria-label={taxon.title}>
      <img
        src={taxon.imageSet?.src ?? taxon.image}
        srcSet={taxon.imageSet?.srcset}
        sizes={taxon.imageSet ? TAXON_CARD_SIZES : undefined}
        alt={taxon.title}
        className="taxon-card__image"
        // Card is a 1:1 aspect-ratio box (.taxon-card { aspect-ratio: 1 }); CSS still fills it via
        // absolute positioning, these attributes just give the browser the ratio before CSS applies.
        width={624}
        height={624}
        loading="lazy"
        fetchpriority="low"
        decoding="async"
      />
      <Badge pill bg="glass" className="taxon-card__badge">
        {taxon.subtitle}
      </Badge>
      <strong className="taxon-card__title">{taxon.title}</strong>
    </Link>
  );
};

export default TaxonCard;
